import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import ICONS from "../../../../assets/Icons";
import StatusContainer from "../../../../components/_utils/CommonStatus/StatusContainer";
import InfoCard from "../../../../components/_utils/CommonStatus/StatusSubComponents/StatusCardContainer/InfoCard";
import TabsWeapperSection from "../../../../components/_utils/CommonStatus/StatusSubComponents/TabsWrapperSection";
import { setHideBreadCrumb } from "../../../../redux/features/hideBreadCrumb/hideBreadCrumb";
import useCategories from "../../../../utils/useCategories";

const BulkTransactionSuccess = () => {
  // const { id } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const categoryMapper = useCategories();

  const [successData, setSuccessData] = useState({});

  const categoryId =
    successData?.category_id?.category_id ?? successData?.category_id;

  const categoryIcon = categoryMapper(categoryId);

  // const viewDetailsHandler = () => {
  //   if (!id) {
  //     console.error("Bulk transaction ID is not available.");
  //     return;
  //   }

  //   navigate(
  //     `/beneficiary_transaction_dashboard/bulk_transaction_view_all/bulk_transaction_detail_page/${id}`,
  //     {
  //       replace: true,
  //     },
  //   );
  // };

  const createTransactionHandler = () => {
    navigate("/beneficiary_transaction_dashboard/create_bulk_transaction", {
      replace: true,
    });
  };

  const dashboardHandler = () => {
    navigate("/beneficiary_transaction_dashboard", {
      replace: true,
    });
  };

  const primaryButtonStyle = {
    enabledBgColor: "var(--text-primary)",
    enabledTextColor: "var(--positive-bg)",
    iconToBeAlign: "left",
    fullWidthRequired: true,
    imgColor: "var(--positive-bg)",
  };

  const buttonRows = [
    [
      {
        ...primaryButtonStyle,
        btnText: "Create bulk transaction",
        icon: ICONS?.ADD_BUTTON_WHITE,
        handleFunction: createTransactionHandler,
      },
      {
        btnText: "Go to dashboard",
        enabledBgColor: "var(--bg-positive-bg)",
        enabledTextColor: "var(--text-primary)",
        icon: ICONS?.DASHBOARD,
        handleFunction: dashboardHandler,
        iconToBeAlign: "left",
        fullWidthRequired: true,
        outLineColor: "var(--text-primary)",
        hoverOption: "dark",
      },
      // {
      //   ...primaryButtonStyle,
      //   btnText: "View details",
      //   icon: ICONS?.VIEW_DETAILS,
      //   handleFunction: viewDetailsHandler,
      // },
    ],
    [
      // {
      //   btnText: "Go to dashboard",
      //   enabledBgColor: "var(--bg-positive-bg)",
      //   enabledTextColor: "var(--text-primary)",
      //   icon: ICONS?.DASHBOARD,
      //   handleFunction: dashboardHandler,
      //   iconToBeAlign: "left",
      //   fullWidthRequired: true,
      //   outLineColor: "var(--text-primary)",
      //   hoverOption: "dark",
      // },
    ],
  ];

  useEffect(() => {
    const storedData = sessionStorage.getItem("uploadTxnStatementData");

    if (!storedData) return;

    try {
      setSuccessData(JSON.parse(storedData));
    } catch (error) {
      console.error("Failed to parse upload transaction data:", error);
      setSuccessData({});
    }
  }, []);

  useEffect(() => {
    dispatch(setHideBreadCrumb({ hide: true }));

    return () => {
      dispatch(setHideBreadCrumb({ hide: false }));
    };
  }, [dispatch]);

  return (
    <div>
      <StatusContainer
        status="success"
        buttonRows={buttonRows}
        title="File has been uploaded successfully and transactions are being processed."
        subtitle="Once the transactions are processed, you will be notified by email."
      >
        <TabsWeapperSection title="Upload details">
          <>
            <InfoCard
              bgColor="var(--positive-card)"
              rows={[
                {
                  leftTitle: successData?.category_name || "Not available",
                  leftSubTitle: "Transaction category",
                  icon: categoryIcon?.url,
                  iconColor: categoryIcon?.colour,
                  iconSize: "small",
                },
              ]}
            />

            <InfoCard
              bgColor="var(--positive-card)"
              rows={[
                {
                  leftTitle:
                    successData?.uploaded_file_data?.metadata?.filename ||
                    "Not available",
                  leftSubTitle: "File name",
                },
              ]}
            />

            {/* <InfoCard
              bgColor="var(--positive-card)"
              rows={[
                {
                  leftTitle: id || "Not available",
                  leftSubTitle: "Transaction ID",
                  copyText: id,
                },
              ]}
            /> */}
          </>
        </TabsWeapperSection>
      </StatusContainer>
    </div>
  );
};

export default BulkTransactionSuccess;
